import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Contact me`}</h2>
    <p>{`You can find me on those platforms: `}<a parentName="p" {...{
        "href": "https://github.com/rossy0213"
      }}>{`Github`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/%E5%BC%98-%E7%94%B0%E6%9D%91-449220189/"
      }}>{`Linkedin`}</a>{` & `}<a parentName="p" {...{
        "href": "https://twitter.com/rossy_0213"
      }}>{`Twitter`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.instagram.com/hongliang0213/?hl=ja"
      }}>{`Instagram`}</a>{` & `}<a parentName="p" {...{
        "href": "https://www.facebook.com/profile.php?id=100009597319394"
      }}>{`Facebook`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      